import { Button, Col, Row, Typography } from 'antd';
import React from 'react';
import CustomInput from './CustomComponents/CustomInput';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons'; // Import the back arrow icon

interface ProceedingHeaderProps {
  proceedingNumber: string;
}

const ProceedingHeader: React.FC<ProceedingHeaderProps> = ({ proceedingNumber }) => {
  return (
    <>
      <Row
        style={{
          padding: '10px',
          marginBottom: '10px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden', 
        }}
      >
        <Col>
          <div
            style={{
              fontSize: '22px', 
              padding: '6px 12px',
              marginRight: '12px',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              height: '50px',
              background: 'white',
              boxShadow: 'none', 
              width: 'auto',
            }}
            className="proceeding-id-box"
          >
            <Typography.Title
              level={5}
              style={{
                marginBottom: 0,
                marginLeft: 0,
                whiteSpace: 'nowrap',
                fontSize: '18px', 
                fontWeight: 'bold',
                color: 'black', 
              }}
            >
              Proceeding ID:&nbsp;
            </Typography.Title>
            <CustomInput
              showInput={false}
              value={proceedingNumber}
              style={{
                fontSize: '18px', 
                fontWeight: 'bold',
                maxWidth: '150px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: 'black', 
              }}
            />
          </div>
        </Col>
        <Col>
          <Link to="/hearing">
            <Button
              type="primary"
              icon={<ArrowLeftOutlined />} 
              style={{ marginLeft: '8px', height: '40px', display: 'flex', alignItems: 'center' }}
            >
              Go To Proceeding List
            </Button>
          </Link>
        </Col>
      </Row>
    </>
  );
};

export default ProceedingHeader;
